module.exports = __webpack_public_path__ + "img/wallet-icon.3be2b49d.png";